<template>
    <div>
        <!-- SPINNER MIENTRAS SE LLAMA -->
        <v-overlay :value="llamada">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- BANNER PERMANENTE PARA ERRORES DE CONEXION -->
        <v-banner v-if="respuestaConexion != ''" single-line dark>
            <v-icon slot="icon" size="36">
                mdi-wifi-strength-alert-outline
            </v-icon>
            {{ respuestaConexion }}
            <template v-slot:actions>
                <v-btn @click="respuestaConexion = ''">Cerrar</v-btn>
            </template>
        </v-banner>

        <!-- SNACKBAR TEMPORAL PARA RESPUESTAS DEL SERVIDOR DE ERROR -->
        <v-snackbar v-if="respuestaError != ''" v-model="snackbarError" multi-line color="#C73146" top :timeout="5000">
            {{ respuestaError }}
            <v-btn color="white" text @click="respuestaError = ''">Cerrar</v-btn>
        </v-snackbar>

        <!-- SNACKBAR TEMPORAL PARA RESPUESTAS DEL SERVIDOR DE OK -->
        <v-snackbar v-if="respuestaOK != ''" v-model="snackbarOK" multi-line color="#9be51a" top :timeout="5000">
            {{ respuestaOK }}
            <v-btn color="white" text @click="respuestaOK = ''">Cerrar</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
  export default {
    data: () => ({
      snackbarError: false,
      snackbarOK: false,
      modal: false
    }),
    computed: {
      llamada () { return this.$API.Llamando },
      respuestaOK: {
        get () { return this.$API.respuestaOK },
        set (valor) { this.$API.respuestaOK = valor }
      },
      respuestaError: {
        get () { return this.$API.respuestaError },
        set (valor) { this.$API.respuestaError = valor }
      },
      respuestaConexion: {
        get () { return this.$API.respuestaConexion },
        set (valor) { this.$API.respuestaConexion = valor }
      }
    },
    watch: {
      // Muestra el snackbar cuando hay mensaje de error
      respuestaError (nuevoValor) { if (nuevoValor != '') this.snackbarError = true },
      // Resetea el mensaje cuando se cierra el snackbarERROR por tiempo
      snackbarError (nuevoValor) { if (!nuevoValor) this.respuestaError = '' },

      // Muestra el snackbar cuando hay mensaje de OK
      respuestaOK (nuevoValor) { if (nuevoValor != '') this.snackbarOK = true },
      // Resetea el mensaje cuando se cierra el snackbarOK por tiempo
      snackbarOK (nuevoValor) { if (!nuevoValor) this.respuestaOK = '' }
    }
  }
</script>

<style lang="scss" scoped>
    .v-banner {
        z-index: 90;
        background-color: #F44336;
    }

    .v-overlay { z-index: 90 !important; }

    .v-snack { font-size: 16px; }
</style>